import { EditableText } from '@smartfire/components';
import { BlockWrapper, defineBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine';
import { lazy, useEffect, useState } from 'react';
import { slugify } from '../../components/utils';
import style from './block.module.scss';

const Inspector = lazy(() => import('./Inspector'));

export const Block = ({ question, placeholder, resetFields }) => {
    useInspectorControl(Inspector);
    const [value, setValue] = useState('');
    const input_id = slugify(`${question}-input`);

    const handleChange = (e) => {
        setValue(e.target.value);
    };

    useEffect(() => {
        if (resetFields) {
            setValue('');
        }
    }, [resetFields]);

    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.top}>
                <EditableText
                    className={style.text}
                    tagName="p"
                    smartProp="question"
                    placeholder="Insérer votre question ..."
                />
            </div>

            <input
                required
                id={input_id}
                name={input_id}
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
            />
        </BlockWrapper.Div>
    );
};
export default defineBlock({
    Block,
    smartProps: {
        question: smartProps.string.withDefault('Question ?'),
        placeholder: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Input',
        parent: ['smartform/quiz-form', 'smartfire/quiz-form---two-columns'],
    },
});
